import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  showAddEditModal,
  showDeleteModal,
} from './store/actions';

import { BusinessUnitPropTypes } from '../../shared/propTypes/businessUnits';

class BusinessUnitSettingsAdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: BusinessUnitPropTypes,

    showAddEditModal: PropTypes.func.isRequired,
    showDeleteModal: PropTypes.func.isRequired,
    rowIndex: PropTypes.number.isRequired,
  };

  showEditModal = () => {
    const { value, showAddEditModal } = this.props;
    showAddEditModal(value);
  };

  showDeleteModal = () => {
    const { value, showDeleteModal, rowIndex } = this.props;
    showDeleteModal({ entity: value, rowIndex });
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Business Unit Settings"
          onClick={this.showEditModal}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete Business Unit Settings"
          onClick={this.showDeleteModal}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  {
    showAddEditModal,
    showDeleteModal,
  }
)(BusinessUnitSettingsAdminColumnRenderer);
